import ApiService from "./api.service";

const SupplierOrders = {
  load: async function (constructionId) {
    let response = await ApiService.get("/construction/" + constructionId + '/orders');
    return response.notes;
  },
  add: async function (constructionId, content) {
    let response = await ApiService.post("/construction/" + constructionId + '/orders', content);
    return response.data;
  },
  delete: async function (constructionId, orderId) {
    await ApiService.delete("/construction/" + constructionId + '/orders/' + orderId, {});
    return true;
  }
};

export default SupplierOrders;
